// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"278":"866708fa","703":"23eeaba6","787":"ce07382d"}[chunkId] + ".chunk.js";
};